<!-- <div *ngIf="loadingFollowUp || loadingBilling || loadingFeedback || loadingReminders || loadingHandover"
	class="loader text-center">
	<img src="../../../assets/img/loading.gif" style="width: 100px;" />
	<p style="color: black;font-weight: bolder;">Loading...</p>
</div> -->
<div *ngIf="loadingFollowUp || loadingReminders" class="loader text-center">
	<img src="../../../assets/img/loading.gif" style="width: 100px;" />
	<p style="color: black;font-weight: bolder;">Loading...</p>
</div>
<div style="background-color: #e6e9ee9c !important;">
	<div class="card">
		<div class="card-body p-1">
			<table class="table mb-1">
				<tbody>
					<tr class="custom-row-1">
						<td class="ps-0">
							<a class="btn btn-sm btn-light float-start me-3" [routerLink]="['/comp/list-appointment']"
								matTooltip="Home">
								<fa-icon [icon]="['fas','sign-out-alt']" [flip]="'horizontal'"></fa-icon>
							</a>
							<span class="float-start me-1" style="line-height: 23px;">
								<strong>
									<fa-icon [icon]="['fas',caseDetails.status==2?'lock':'lock-open']"
										matTooltip="{{ caseDetails?.case_status }}" class="float-end"></fa-icon>
								</strong>
							</span>
							<span class="float-start me-3">
								Case Id:
								<strong>
									{{caseDetails.case_id}}
								</strong>
							</span>
							<span class="float-start me-3">
								Start Date:
								<strong>
									{{caseDetails?.start_date}}
								</strong>
							</span>
							<span class="float-start me-3">
								Vessel:
								<strong>
									{{caseDetails.vessel || '___'}}
								</strong>
							</span>
							<span class="float-start me-3">
								Company:
								<strong>
									{{caseDetails?.company?.name || '___'}}
								</strong>
							</span>
							<label class="checkmark-container float-end text-light">
								Mark for closure
								<input type="checkbox" id="checkMarkForClosure" [(ngModel)]="mark_for_closure"
									[disabled]="true" />
								<span class="checkmark"></span>
							</label>
							<label class="checkmark-container float-end text-light me-4">
								Ready to bill
								<input type="checkbox" id="checkReadyToBill" [(ngModel)]="ready_to_bill"
									[disabled]="true" />
								<span class="checkmark"></span>
							</label>
						</td>
					</tr>
				</tbody>
			</table>
			<div class="row g-1">
				<div class="col-lg-3 pe-1">
					<div class="card overflow-x-hidden">
						<div class="card-header p-1 mb-0 bg-theme-1">
							<h5 class="card-title text-dark text-center mb-0">
								Crew Details
							</h5>
						</div>
						<div class="card-body">
							<table class="table">
								<tbody>
									<tr>
										<td>
											<div class="row g-1">
												<div class="col-md-4">
													Name
												</div>
												<div class="col-md-8">
													<strong>
														{{ caseDetails?.f_name }}
														&nbsp;
														{{ caseDetails?.l_name }}
													</strong>
												</div>
											</div>
										</td>
									</tr>
									<tr>
										<td>
											<div class="row g-1">
												<div class="col-md-4">
													Crew-Id
												</div>
												<div class="col-md-8">
													<strong>
														{{caseDetails?.crew_id || "___"}}
													</strong>
												</div>
											</div>
										</td>
									</tr>
									<tr>
										<td>
											<div class="row g-1">
												<div class="col-md-4">
													Rank
												</div>
												<div class="col-md-8">
													<strong>
														{{ caseDetails?.rank_name || "___" }}
													</strong>
												</div>
											</div>
										</td>
									</tr>
									<tr>
										<td>
											<div class="row g-1">
												<div class="col-md-4">
													Date of Birth
												</div>
												<div class="col-md-8">
													<strong>
														{{caseDetails?.dob || "___"}}
													</strong>
												</div>
											</div>
										</td>
									</tr>
									<tr>
										<td>
											<div class="row g-1">
												<div class="col-md-4">
													Telephone No.
												</div>
												<div class="col-md-8">
													<strong>
														{{caseDetails?.country_code}}
														&nbsp;
														{{caseDetails?.tel_no || '___'}}
													</strong>
												</div>
											</div>
										</td>
									</tr>
									<tr>
										<td>
											<div class="row g-1">
												<div class="col-md-4">
													Email-Id
												</div>
												<div class="col-md-8">
													<strong>
														{{caseDetails?.email || '___'}}
													</strong>
												</div>
											</div>
										</td>
									</tr>
									<tr>
										<td>
											<div class="row g-1">
												<div class="col-md-4">
													Address
												</div>
												<div class="col-md-8">
													<strong>
														{{caseDetails?.address || '___'}}
													</strong>
												</div>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<div class="card overflow-x-hidden" *ngIf="caseDetails.status == 2">
						<div class="card-header p-1 mb-0 bg-theme-1">
							<h5 class="card-title text-dark text-center mb-0">
								Closure Details
							</h5>
						</div>
						<div class="card-body">
							<table class="table">
								<tbody>
									<tr>
										<td>
											<div class="row g-1">
												<div class="col-md-12">
													Closure Status:
												</div>
												<div class="col-md-12">
													<strong>
														{{
														caseDetails?.status4_name ||
														"___"
														}}
													</strong>
												</div>
											</div>
										</td>
									</tr>
									<tr>
										<td>
											<div class="row g-1">
												<div class="col-md-12">
													Closure Notes:
												</div>
												<div class="col-md-12">
													<span [innerHTML]="caseDetails?.closure_notes||'___'">
													</span>
												</div>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<div class="card overflow-x-hidden">
						<div class="card-header p-1 mb-0 bg-theme-3">
							<h5 class="card-title text-dark text-center mb-0">
								Reminders
							</h5>
						</div>
						<div class="card-body overflow-y-auto notes-max-height">
							<ng-container *ngIf="caseReminder">
								<ul class="text-reminder">
									<li *ngIf="caseReminder.crew_details_not_filled">
										<h5 class="mb-0">
											Please fill crew details.
										</h5>
									</li>
									<li *ngIf="caseReminder.data_not_filled">
										<h5 class="mb-0">
											Please fill key evaluations.
										</h5>
									</li>
									<li *ngIf="caseReminder.mark_for_closure">
										<h5 class="mb-0">
											Case is marked for closure but not closed.
										</h5>
									</li>
									<li *ngIf="caseReminder.incomplete_billing.length">
										<h5 class="mb-0">
											Billing is incomplete in following follow-ups:
										</h5>
										<ul>
											@for (followup of caseReminder.incomplete_billing; track $index) {
											<li>
												<h5 class="mb-0">
													<a
														[routerLink]="['/comp/'+currentURLSegment,uId,followup.followup_encid]">
														{{followup.date}}
													</a>
												</h5>
											</li>
											}
										</ul>
									</li>
									<li *ngIf="caseReminder.files_not_uploaded.length">
										<h5 class="mb-0">
											File are missing in following follow-ups:
										</h5>
										<ul>
											@for (followup of caseReminder.files_not_uploaded; track $index) {
											<li>
												<h5 class="mb-0">
													<a
														[routerLink]="['/comp/'+currentURLSegment,uId,followup.followup_encid]">
														{{followup.date}}
													</a>
												</h5>
											</li>
											}
										</ul>
									</li>
								</ul>
							</ng-container>
						</div>
					</div>
					<div class="card overflow-x-hidden">
						<div class="card-header p-1 mb-0 bg-theme-4">
							<h5 class="card-title text-dark text-center mb-0">
								Case Notes
							</h5>
						</div>
						<div class="card-body overflow-y-auto notes-max-height">
							<table class="table">
								<tbody>
									<tr *ngFor="let notes of caseDetails?.opd_notes;let i = index;">
										<td>
											<p class="mb-0">
												<label>Date: </label>
												{{notes?.follow_up_date}}
											</p>
											<p class="mb-0">
												<label>Medical Centre: </label>
												{{notes?.dropoff_hospital}}
											</p>
											<p class="mb-0">
												<label>Notes: </label>
												<span *ngIf="notes?.opd_notes" [innerHTML]="notes?.opd_notes | safeHtml"
													class="case-notes-html"></span>
											</p>
											<p class="mb-0">
												<label>Updated by: </label>
												{{notes?.opd_notes_updated_by || "___"}}
											</p>
											<p class="mb-0">
												<label>Updated At: </label>
												{{notes?.opd_notes_updated_at || "___"}}
											</p>
											<div *ngIf="notes.lab_test_files" class="card p-2 d-block">
												<ng-container *ngFor="let files of notes.lab_test_files;let j = index;">
													<div *ngFor="let file of files.files;let k = index;"
														class="icon-container">
														<file-icon [file]="file"></file-icon>
													</div>
												</ng-container>
												<p class="mb-0" *ngIf="!notes.lab_test_files.length">
													No Files
												</p>
											</div>
										</td>
									</tr>
									<tr *ngIf="!caseDetails?.opd_notes?.length">
										<td class="text-center">No notes found.</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
				<div class="col-lg-9 ps-1">
					<div class="row g-1">
						<div class="col-lg-4 pe-1">
							<div class="card overflow-x-hidden key-eval-height">
								<div class="card-header p-1 mb-0 bg-theme-1">
									<h5 class="card-title text-dark text-center mb-0">
										Key Evaluations
										<strong class="text-danger" *ngIf="isKeyEvalIncomplete()">
											(Incomplete)
										</strong>
									</h5>
								</div>
								<div class="card-body overflow-y-auto">
									<table class="table">
										<tbody>
											<tr>
												<td>
													<div class="row g-0">
														<div class="col">
															<p class="mb-0">
																<label>Hospitalized</label>
															</p>
															<div class="col-sm-12 ps-1">
																{{
																caseDetails?.other_details?.hospitalization_status ||
																"___"
																}}
															</div>
														</div>
														<div class="col">
															<p class="mb-0">
																<label>Hospitalization Date</label>
															</p>
															<div class="col-sm-12 ps-1">
																{{
																caseDetails?.other_details?.admission_date ||
																"___"
																}}
															</div>
														</div>
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<div class="row g-0">
														<div class="col">
															<p class="mb-0">
																<label>Surgery Required</label>
															</p>
															<div class="col-sm-12 ps-1">
																{{
																caseDetails?.other_details?.surgery_status ||
																"___"
																}}
															</div>
														</div>
														<div class="col">
															<p class="mb-0">
																<label>Surgery Date</label>
															</p>
															<div class="col-sm-12 ps-1">
																{{
																caseDetails?.other_details?.actual_surgery_date ||
																"___"
																}}
															</div>
														</div>
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<div class="row g-0">
														<div class="col">
															<p class="mb-0">
																<label>Any Disability</label>
															</p>
															<div class="col-sm-12 ps-1">
																{{
																caseDetails?.disability ||
																"___"
																}}
															</div>
														</div>
														<div class="col">
															<p class="mb-0">
																<label>Disability %</label>
															</p>
															<div class="col-sm-12 ps-1">
																{{
																caseDetails?.disability_per ||
																"___"
																}}
															</div>
														</div>
													</div>
													<div class="row g-0">
														<div class="col">
															<p class="mb-0">
																<label>
																	Disability Notes
																	<fa-icon [icon]="['fas','info']" role="button"
																		matTooltip="View"
																		(click)="showDisabilityModal()">
																	</fa-icon>
																</label>
															</p>
														</div>
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<div class="row g-0">
														<div class="col">
															<p class="mb-0">
																<label>PT Sessions</label>
															</p>
															<div class="col-sm-12 ps-1">
																{{
																caseDetails?.other_details?.physiotherapy_session_counts
																||
																"___"
																}}
															</div>
														</div>
														<div class="col">
															<p class="mb-0">
																<label>Imp. %</label>
															</p>
															<div class="col-sm-12 ps-1">
																{{
																caseDetails?.other_details?.physiotherapy_percentage ||
																"___"
																}}
															</div>
														</div>
													</div>
													<div class="row g-0">
														<div class="col">
															<p class="mb-0">
																<label>
																	PT Notes
																	<fa-icon [icon]="['fas','info']" role="button"
																		matTooltip="View" (click)="showPhysioModal()">
																	</fa-icon>
																</label>
															</p>
														</div>
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<p class="mb-0">
														<label>
															Expected Closure Date
														</label>
													</p>
													<div class="col-sm-12 ps-1">
														{{caseDetails?.expected_closure_date_display || "___"}}
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<p class="mb-0">
														<label>
															ICD Code
														</label>
													</p>
													<div class="col-sm-12 ps-1">
														{{caseDetails?.icd_code || "___"}}
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<p class="mb-0">
														<label>
															Diagnosis
														</label>
													</p>
													<div class="col-sm-12 ps-1">
														{{caseDetails?.diagnosis || "___"}}
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<p class="mb-0">
														<label>
															Medical History
														</label>
													</p>
													<div class="col-sm-12 pl-xl">
														<span *ngIf="caseDetails?.medical_history"
															[innerHTML]="caseDetails?.medical_history | safeHtml"></span>
														<span *ngIf="!caseDetails?.medical_history">
															___
														</span>
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<p class="mb-0">
														<label>
															Work related
														</label>
													</p>
													<div class="col-sm-12 pl-xl">
														{{caseDetails?.work_related?"Yes":"___"}}
													</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
						<div class="col-lg-4 ps-1 pe-1">
							<div class="card overflow-x-hidden onboard-details-height">
								<div class="card-header p-1 mb-0 bg-theme-2">
									<h5 class="card-title text-dark text-center mb-0">
										Onboard Case Details
									</h5>
								</div>
								<div class="card-body overflow-y-auto">
									<table class="table">
										<tbody>
											<tr>
												<td>
													<p class="mb-0">
														<label>Initial Complaints</label>
													</p>
													<div class="col-sm-12 pl-xl">
														<span *ngIf="caseDetails?.initial_complaints"
															[innerHTML]="caseDetails?.initial_complaints | safeHtml"></span>
														<span *ngIf="!caseDetails?.initial_complaints">
															___
														</span>
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<div class="row g-0">
														<div class="col">
															<p class="mb-0">
																<label>
																	Sign-off Date
																</label>
															</p>
															<div class="col-sm-12 pl-xl">
																{{caseDetails?.sign_off_date || "___"}}
															</div>
														</div>
														<div class="col">
															<p class="mb-0">
																<label>Sign-off By</label>
															</p>
															<div class="col-sm-12 pl-xl">
																{{caseDetails?.sign_off_by || "___"}}
															</div>
														</div>
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<p class="mb-0">
														<label>Symptoms</label>
													</p>
													<div class="col-sm-12 pl-xl">
														<div *ngIf="caseDetails?.symptoms">
															<span
																*ngFor="let sysd of caseDetails?.symptoms;last as isLast;"
																class="fs_14">
																{{sysd}}{{isLast ? '' : ', '}}
															</span>
														</div>
														<div
															*ngIf="!caseDetails?.symptoms || !caseDetails?.symptoms.length">
															___
														</div>
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<p class="mb-0">
														<label>Sub-Symptoms</label>
													</p>
													<div class="col-sm-12 pl-xl">
														<div *ngIf="subsymptoms.length">
															<span *ngFor="let sysd of subsymptoms;last as isLast;"
																class="fs_14">
																{{sysd}}{{isLast ? '' : ', '}}
															</span>
														</div>
														<div *ngIf="!subsymptoms.length">
															___
														</div>
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<p class="mb-0">
														<label>Medications Onboard</label>
													</p>
													<div class="col-sm-12">
														<table class="table table-striped table-bordered"
															*ngIf="caseDetails?.medications_onboard?.length > 0"
															id="medicineTable">
															<thead>
																<tr>
																	<th matTooltip="Date">
																		<fa-icon [icon]="['fas','calendar']"></fa-icon>
																	</th>
																	<th matTooltip="Name">
																		<fa-icon [icon]="['fas','medkit']"></fa-icon>
																	</th>
																	<th matTooltip="Dosage">
																		<fa-icon [icon]="['fas','medkit']"></fa-icon>
																	</th>
																	<th matTooltip="Frequency">
																		<fa-icon [icon]="['fas','list-ol']"></fa-icon>
																	</th>
																	<th matTooltip="No. Of Days">
																		<fa-icon
																			[icon]="['fas','calendar-alt']"></fa-icon>
																	</th>
																</tr>
															</thead>
															<tbody>
																<tr
																	*ngFor="let field of caseDetails?.medications_onboard; let i = index">
																	<td>
																		{{field.medDate }}
																	</td>
																	<td>
																		{{field.name}}
																	</td>
																	<td>
																		{{field.qty}}
																	</td>
																	<td>
																		<fa-icon *ngIf="field.morning"
																			[icon]="['fas','sun']"
																			class="text-success me-1"
																			matTooltip="Morning"></fa-icon>
																		<fa-icon *ngIf="field.afternoon"
																			[icon]="['fas','sun']"
																			class="text-warning me-1"
																			matTooltip="Afternoon"></fa-icon>
																		<fa-icon *ngIf="field.evening"
																			[icon]="['fas','moon']"
																			class="text-primary me-1"
																			matTooltip="Evening"></fa-icon>
																		<fa-icon *ngIf="field.sos"
																			[icon]="['fas','exclamation-triangle']"
																			class="text-danger me-1"
																			matTooltip="SOS"></fa-icon>
																	</td>
																	<td>
																		{{field.noOfDays}}
																	</td>
																</tr>
															</tbody>
														</table>
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<p class="mb-0">
														<label>Medical Summary</label>
													</p>
													<div class="col-sm-12 pl-xl">
														<span *ngIf="caseDetails?.medical_summary"
															[innerHTML]="caseDetails?.medical_summary | safeHtml"></span>
														<span *ngIf="!caseDetails?.medical_summary">
															___
														</span>
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<div class="row g-0">
														<div class="col">
															<p class="mb-0">
																<label>Reported As</label>
															</p>
															<div class="col-sm-12 pl-xl">
																{{caseDetails?.reported_as || "___"}}
															</div>
														</div>
														<div class="col">
															<p class="mb-0">
																<label>Port Visit?</label>
															</p>
															<div class="col-sm-12 pl-xl">
																{{getPortVisitText(caseDetails?.port_visit_done) ||
																"___"}}
															</div>
														</div>
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<p class="mb-0">
														<label>Assigned Dr. RMA</label>
													</p>
													<div class="col-sm-12 pl-xl">
														{{caseDetails?.assigned_dr_rma || "___"}}
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<p class="mb-0">
														<label>Crew Chronic Conditions</label>
													</p>
													<div class="col-sm-12 pl-xl">
														{{caseDetails?.crew_chronic_conditions || "___"}}
													</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
						<div class="col-lg-4 pe-1">
							<div class="row g-1">
								<div class="col text-center">
									<div class="card p-1 data-card" [ngClass]="getClass(caseDetails?.case_days)">
										<p class="data-card-value fw-bold">
											{{ caseDetails?.case_days || "___" }}
										</p>
										<p class="data-card-label">
											Case Days Open
										</p>
									</div>
								</div>
								<div class="col text-center">
									<div class="card p-1 data-card text-light"
										[ngClass]="'bg-'+getTriage(caseDetails?.triage).color">
										<p class="data-card-value">
											<i class="bi bi-flag-fill">
											</i>
											{{
											getTriage(caseDetails?.triage).text
											}}
										</p>
										<p class="data-card-label">
											Triage Code
										</p>
									</div>
								</div>
							</div>
							<div class="row g-1">
								<div class="col text-center">
									<div class="card p-1 data-card bg-theme">
										<p class="data-card-value">
											{{ caseDetails?.case_category || "___" }}
										</p>
										<p class="data-card-label">
											Case Category
										</p>
									</div>
								</div>
								<div class="col text-center">
									<div class="card p-1 data-card bg-theme">
										<p class="data-card-value">
											{{
											caseDetails?.assigned_sc_agent?.name ||
											"___"
											}}
										</p>
										<p class="data-card-label">
											SC Doctor
										</p>
									</div>
								</div>
							</div>
							<!-- <div class="row g-1">
								<div class="col text-center">
									<div class="card p-1 data-card bg-theme">
										<p class="data-card-value">
											{{
											caseDetails?.bill_details?.status ||
											"___"
											}}
										</p>
										<p class="data-card-label">
											Billed Status
										</p>
									</div>
								</div>
								<div class="col text-center">
									<div class="card p-1 data-card bg-theme">
										<p class="data-card-value">
											{{ caseDetails?.bill_details?.date || "___" }}
										</p>
										<p class="data-card-label">
											Billed Date
										</p>
									</div>
								</div>
							</div> -->
							<div class="row g-1">
								<div class="col text-center">
									<div class="card p-1 data-card bg-theme">
										<p class="data-card-value">
											{{
											caseDetails?.other_details?.last_report ||
											"___"
											}}
										</p>
										<p class="data-card-label">
											Last Report
										</p>
									</div>
								</div>
								<!-- <div class="col text-center">
									<div class="card p-1 data-card bg-theme">
										<p class="data-card-value">
											<fa-icon [icon]="['fas','rupee-sign']"></fa-icon>
											{{
											caseDetails?.total_cost ||
											"___"
											}}
										</p>
										<p class="data-card-label">
											Total Bill
										</p>
									</div>
								</div> -->
							</div>
						</div>
					</div>
					<div class="row g-1">
						<div class="col-lg-12">
							<ul class="nav nav-tabs nav-tabs-bordered mb-2" role="tablist">
								<li class="nav-item" role="button" (click)="setActiveTab(0)">
									<a class="nav-link" [ngClass]="getTabClass(0)" data-bs-toggle="tab" role="tab"
										aria-controls="ex1-tabs-1" aria-selected="true">
										Follow-up
									</a>
								</li>
								<!-- <li class="nav-item" role="button" (click)="setActiveTab(1)">
									<a class="nav-link" [ngClass]="getTabClass(1)" data-bs-toggle="tab" role="tab"
										aria-controls="ex1-tabs-1" aria-selected="true">
										Billing
									</a>
								</li>
								<li class="nav-item" role="button" (click)="setActiveTab(2)">
									<a class="nav-link" [ngClass]="getTabClass(2)" data-bs-toggle="tab" role="tab"
										aria-controls="ex1-tabs-1" aria-selected="true">
										Feedback
									</a>
								</li>
								<li class="nav-item" role="button" (click)="setActiveTab(3)">
									<a class="nav-link" [ngClass]="getTabClass(3)" data-bs-toggle="tab" role="tab"
										aria-controls="ex1-tabs-1" aria-selected="true">
										Non-Medical/Handover
									</a>
								</li> -->
							</ul>
							<div class="tab-content">
								<div [ngClass]="getTabPaneClass(0)">
									<div class="row g-0">
										<div class="col-md-3 followUpListBox">
											<ng-container *ngIf="!loadingFollowUp">
												@for( card of followupList; track $index){
												<div class="card followup-card mb-1"
													[routerLink]="['/comp/'+currentURLSegment,uId,card.enc_id]"
													[routerLinkActive]="'selected'" style="cursor: pointer">
													<div class="card-body p-2">
														<div class="row g-0 text-uppercase">
															<div class="col">
																<span class="badge bg-secondary text-light fw-bold">
																	{{ card?.follow_up_date }}
																</span>
																<img *ngIf="card?.visit_type"
																	src="../../assets/img/appt-types/{{appt_type_images[card?.visit_type?.name]}}"
																	class="appt-type-img ms-1"
																	[matTooltip]="card?.visit_type?.name" />
															</div>
															<div class="col text-end">
																<span class="badge fw-bold text-dark"
																	[ngClass]="getFollowUpStatusClass(card.follow_up_status?.id)">
																	{{ card?.follow_up_status?.name }}
																</span>
															</div>
														</div>
														<div class="row g-0 text-uppercase fw-bold mt-1">
															<div class="col hospital-name">
																@if (card?.dropoff_hospital) {
																{{
																card?.dropoff_hospital?.name
																}}
																}@else {
																&nbsp;
																}
															</div>
														</div>
													</div>
												</div>
												}
											</ng-container>
										</div>
										<div class="col-md-9" [@routeAnimations]="prepareRoute(o)">
											<router-outlet #o="outlet"></router-outlet>
										</div>
									</div>
								</div>
								<!-- <div [ngClass]="getTabPaneClass(1)">
									<div class="row g-1">
										<div class="col-md-12">
											<div class="card" @fadeInOut *ngIf="!loadingBilling">
												<div class="card-header">
													<h5 class="card-title text-dark mb-0">
														Billing
													</h5>
												</div>
												<div class="card-body">
													<table class="table table-bordered">
														<thead>
															<tr>
																<th style="width: 5% !important;">Sr. No.</th>
																<th style="width: 10% !important;">Date</th>
																<th style="width: 10% !important;">Category</th>
																<th style="width: 14% !important;">Notes</th>
																<th style="width: 10% !important;">Amount</th>
																<th style="width: 15% !important;">Files</th>
																<th style="width: 15% !important;">QR Code</th>
																<th style="width: 15% !important;">Gpay</th>
																<th style="width: 6% !important;">Paid</th>
																<th style="width: 5% !important;">Approval</th>
																<th style="width: 5% !important;">Reimbursement</th>
																<th style="width: 5% !important;">Billed</th>
															</tr>
														</thead>
														<tbody>
															<ng-container
																*ngFor="let bill of followUpBillsData;let i = index;">
																<tr
																	[ngClass]="{ 'orange': !bill.files || bill.files.length==0 }">
																	<td>
																		{{ i+1 }}
																	</td>
																	<td>
																		{{bill.date}}
																	</td>
																	<td>
																		{{bill.category_name}}
																	</td>
																	<td>
																		{{bill.notes}}
																	</td>
																	<td>
																		{{bill.amount}}
																	</td>
																	<td>
																		<ng-container *ngIf="bill.files">
																			<div *ngFor="let file of bill.files;let j = index;"
																				class="icon-container no-delete">
																				<file-icon [file]="file"></file-icon>
																			</div>
																		</ng-container>
																	</td>
																	<td>
																		<ng-container *ngIf="bill.qrcode_files">
																			<div *ngFor="let file of bill.qrcode_files;let j = index;"
																				class="icon-container no-delete">
																				<file-icon [file]="file"></file-icon>
																			</div>
																		</ng-container>
																	</td>
																	<td>
																		<ng-container *ngIf="bill.gpay_files">
																			<div *ngFor="let file of bill.gpay_files;let j = index;"
																				class="icon-container no-delete">
																				<file-icon [file]="file"></file-icon>
																			</div>
																		</ng-container>
																	</td>
																	<td>
																		<fa-icon *ngIf="bill.is_paid"
																			[icon]="['fas', 'check']"
																			class="text-success"></fa-icon>
																	</td>
																	<td>
																		<fa-icon *ngIf="bill.is_approved"
																			[icon]="['fas', 'check']"
																			class="text-success"></fa-icon>
																	</td>
																	<td>
																		<fa-icon *ngIf="bill.reimbursement"
																			[icon]="['fas', 'check']"
																			class="text-success"></fa-icon>
																	</td>
																	<td>
																		<fa-icon *ngIf="bill.used_in_invoice"
																			[icon]="['fas', 'check']"
																			class="text-success"></fa-icon>
																	</td>
																</tr>
															</ng-container>
															<tr>
																<th colspan="4" class="text-end">Total</th>
																<td colspan="6">{{ caseDetails?.total_cost }}</td>
															</tr>
														</tbody>
													</table>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div [ngClass]="getTabPaneClass(2)">
									<div class="row g-1 feedback" @fadeInOut *ngIf="!loadingFeedback">
										<div class="col-md-12">
											@for (main of feedbackQuestions; track main.que_id) {
											<div class="card">
												<div class="card-header">
													<h5 class="card-title text-dark mb-0">
														{{main.name}}
													</h5>
												</div>
												<div class="card-body">
													<ng-container *ngIf="main.ans_details.length">
														<mat-radio-group [(ngModel)]="main.ans_given"
															*ngIf="main.ans_details[0].display_name != 'Other'"
															[disabled]="true">
															<mat-radio-button [value]="ans.value" [color]="'primary'"
																*ngFor="let ans of main.ans_details;">
																{{ans.display_name}}
															</mat-radio-button>
														</mat-radio-group>
														<textarea class="form-control" [(ngModel)]="main.other_text"
															*ngIf="main.ans_details[0].display_name == 'Other'"
															[readonly]="true"></textarea>
														<textarea class="form-control" [(ngModel)]="main.other_text"
															*ngIf="showOtherInput(main.ans_given,main.ans_details)"
															[readonly]="true"></textarea>
													</ng-container>
													<ng-container
														*ngIf="!main.ans_details.length && main.sub_questions.length">
														<table class="table table-bordered">
															<tbody>
																<tr *ngFor="let sub of main.sub_questions">
																	<th>{{sub.name}}</th>
																	<td>
																		<mat-radio-group [(ngModel)]="sub.ans_given"
																			*ngIf="sub.ans_details[0].display_name != 'Other'"
																			[disabled]="true">
																			<mat-radio-button [value]="ans.value"
																				[color]="'primary'"
																				*ngFor="let ans of sub.ans_details;">
																				{{ans.display_name}}
																			</mat-radio-button>
																		</mat-radio-group>
																	</td>
																</tr>
															</tbody>
														</table>
													</ng-container>
												</div>
											</div>
											}
										</div>
									</div>
								</div>
								<div [ngClass]="getTabPaneClass(3)">
									<div class="row g-1" @fadeInOut *ngIf="!loadingHandover">
										<div class="col-md-12">
											@if (nonMedicalList.length) {
											@for (handover of nonMedicalList; track $index) {
											<div class="card">
												<div class="card-header bg-light">
													<h5 class="card-title text-dark mb-0">
														{{handover.follow_up_date}}
														<strong class="ms-3">
															{{handover.is_handover?"Handover":"Non-Medical"}}
														</strong>
														<ng-container *ngIf="handover.is_handover_done">
															<strong class="ms-3">
																Done
																<fa-icon [icon]="['fas','check']"
																	class="text-success"></fa-icon>
															</strong>
														</ng-container>
													</h5>
												</div>
												<div class="card-body" [innerHTML]="handover.opd_notes | safeHtml">
												</div>
											</div>
											}
											}@else {
											<div class="card">
												<div class="card-body">
													<h3 class="text-center">
														No Follow-ups
													</h3>
												</div>
											</div>
											}
										</div>
									</div>
								</div> -->
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="displayNoteModal" role="dialog">
	<div class="modal-dialog modal-md">
		<div class="modal-content">
			<div class="modal-header text-center">
				<h4 class="modal-title">
					<strong>{{modalNotesDetail.heading}}</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				<div class="row g-1">
					<div class="col-lg-12" [innerHTML]="modalNotesDetail.note || '___' | safeHtml">
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal">
					Close
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="hospitalizationViewModal" role="dialog">
	<div class="modal-dialog modal-md">
		<div class="modal-content">
			<div class="modal-header text-center">
				<h4 class="modal-title">
					<strong>Hospitalization Details</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				<table class="table table-bordered">
					<tbody>
						<tr>
							<th style="width: 40%;">Hospitalization</th>
							<td style="width: 60%;">
								{{
								caseDetails?.other_details?.hospitalization_status ||
								"___"
								}}
							</td>
						</tr>
						<tr>
							<th>Hospitalization Date</th>
							<td>
								{{
								caseDetails?.other_details?.admission_date ||
								"___"
								}}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal">
					Close
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="surgeryViewModal" role="dialog">
	<div class="modal-dialog modal-md">
		<div class="modal-content">
			<div class="modal-header text-center">
				<h4 class="modal-title">
					<strong>Surgery Details</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				<table class="table table-bordered">
					<tbody>
						<tr>
							<th style="width: 40%;">Surgery</th>
							<td style="width: 60%;">
								{{
								caseDetails?.other_details?.surgery_status ||
								"___"
								}}
							</td>
						</tr>
						<tr>
							<th>Surgery Date</th>
							<td>
								{{
								caseDetails?.other_details?.actual_surgery_date ||
								"___"
								}}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal">
					Close
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="disabilityViewModal" role="dialog">
	<div class="modal-dialog modal-md">
		<div class="modal-content">
			<div class="modal-header text-center">
				<h4 class="modal-title">
					<strong>Disability Notes</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				{{caseDetails?.disability_notes || "___"}}
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal">
					Close
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="physiotherapyViewModal" role="dialog">
	<div class="modal-dialog modal-md">
		<div class="modal-content">
			<div class="modal-header text-center">
				<h4 class="modal-title">
					<strong>Physiotherapy Notes</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				{{
				caseDetails?.other_details?.physiotherapy_notes ||
				"___"
				}}
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal">
					Close
				</button>
			</div>
		</div>
	</div>
</div>